<template>
    <v-dialog
    v-model="show"
    persistent
    width="480">
   
    <v-card color="light_gray">
        <v-toolbar   dense  >
            <v-icon left >mdi-cog</v-icon><span class="va-underline">Product Properties </span>
            <v-spacer/>
            <v-icon  @click="emitToParent()">mdi-close</v-icon>
          </v-toolbar>
          <v-card-text class="pa-4">
            <p class="def-font">Product properties refer to the specific characteristics, features, or attributes that define a product
              <a @click="INFO()">learn more...</a></p>
              <v-divider />
              <v-text-field
              v-model="propName"
               append-icon="mdi-plus"
               @click:append="addProp"
               @keyup.enter="addProp"
                label="Add Property"
              /> 
               <v-chip v-for="(item, index) in properties" :key="index" class="ma-1" block elevation="1" color="primary">
                   <v-icon left small @click="removeProp(index)">mdi-close-circle</v-icon> {{item.name}}
               </v-chip>
          </v-card-text>

    </v-card>
  
  </v-dialog>
</template>

<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
export default {
    mixins: [API_MIXINS],
  props: {
      show:{
          type: Boolean,
          default: false
      },
      data: {
          type: Object,
          default: ()=>{}
      },
      state: {
        type: String,
        default:"new"
      }

  },
  data () {
      return {
        valid: true,
        propName:'',
        properties:[],
        product:{},
      }
    },
  watch: {
    show(v){
      if(v) {
       if(this.state !='new') {
          this.product = this.data
          if(this.data.properties !== null) {
            this.properties = this.data.properties
          }
       }
      } else {
        this.product = {}
        this.properties = []
        this.propName =""
      }
    }
  },
  computed:{
    
  },
  methods: {
   emitToParent () {
      this.$emit('DialogEvent', this.properties)
    },
    addProp() {
        if(this.propName.length>2){
            let prop = {
              name: this.propID(this.propName),
              value: ""
            }
            this.properties.push(prop);
            this.propName = ''
            if(this.state !='new') { this.updateProduct()}

        }
    },
    propID(name){
        let val = this.$capitalize(name.trim())
        return val
    },
    removeProp(index){
      this.properties.splice(index,1)
      this.updateProduct()
    },
    updateProduct() { 
      this.product.properties = this.properties
        this.$http.post("update_product", this.product).then(response => {
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
        
        }).catch(e => {
          console.log(e.data)
        })
     },
  }
}
</script>
